export default __webpack_public_path__ + "mb-user2e4d03.svg";